import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import UpdateAnnouncements from "@/pages/admin/UpdateAnnouncements";
export const Route = createFileRoute("/admin/announcements")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><UpdateAnnouncements /></ProtectedRoute>) });
